// Markdown.tsx
import { Fragment } from 'react'
import ReactMarkdown from 'react-markdown'
import type { Components } from 'react-markdown'

import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import remarkBreaks from 'remark-breaks' // ← add this

type MarkdownProps = {
  content?: string
  linkDisplayText?: string
  sessionId?: string | null
  baseHost?: string | null // e.g. dev.inoviaai.se
  isInbox?: boolean // e.g. dev.inoviaai.se
  lastMessage?: boolean // e.g. dev.inoviaai.se
}

export default function Markdown({
  content,
  linkDisplayText,
  sessionId,
  baseHost,
  isInbox,
  lastMessage
}: MarkdownProps) {
  if (!content) return <Fragment />

  content = sessionId
    ? content.replaceAll('{aiva.conversation_id}', sessionId)
    : content
  content = content.replace(/<br\s*\/?>/gi, '\n\n')

  const BANK_ID_BASE = `https://${baseHost}/bankid-ui`
  const CGI_EID_BASE = `https://${baseHost}/cgi-eid-ui`

  // Renderer for <BankID .../>
  const BankID = ({ node }: any) => {
    // read <BankID company="unak"/>

    if (isInbox || !lastMessage) {
      return (
        <div className="message-text">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={customComponents}
          >
            {isInbox && !lastMessage
              ? 'BankID was displayed to user'
              : isInbox && lastMessage
              ? 'BankID is displayed to user'
              : 'BankID identification'}
          </ReactMarkdown>
        </div>
      )
    }

    const company: string | undefined =
      node?.properties?.company?.toString().trim() || undefined

    const bankIdUrl = new URL(BANK_ID_BASE)
    if (sessionId) bankIdUrl.searchParams.set('conversationId', sessionId)
    if (company) bankIdUrl.searchParams.set('company', company)

    return (
      <div className="bankid-frame">
        <iframe
          src={bankIdUrl.toString()}
          width="100%"
          height={650}
          style={{ border: 'none' }}
          sandbox="allow-forms allow-same-origin allow-scripts"
        />
      </div>
    )
  }

  const CgiEid = ({ node }: any) => {
    // read <CgiEid company="unak"/>

    if (isInbox || !lastMessage) {
      return (
        <div className="message-text">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={customComponents}
          >
            {isInbox && !lastMessage
              ? 'CgiEid was displayed to user'
              : isInbox && lastMessage
              ? 'CgiEid is displayed to user'
              : 'CgiEid identification'}
          </ReactMarkdown>
        </div>
      )
    }

    const company: string | undefined =
      node?.properties?.company?.toString().trim() || undefined

    const cgiEidUrl = new URL(CGI_EID_BASE)
    if (sessionId) cgiEidUrl.searchParams.set('conversationId', sessionId)
    if (company) cgiEidUrl.searchParams.set('company', company)

    return (
      <div className="bankid-frame">
        <iframe
          src={cgiEidUrl.toString()}
          width="100%"
          height={650}
          style={{ border: 'none' }}
          sandbox="allow-forms allow-same-origin allow-scripts"
        />
      </div>
    )
  }

  const customComponents = {
    bankid:BankID,
    cgieid:CgiEid
  } as unknown as Components

  return (
    <div className="message-text">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw]}
        components={customComponents}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
